module.exports = __webpack_public_path__ + "static/media/Nota cómo organizar una cena navideña.346cb48a.png";